import * as React44ms from "../../../Util/form-utils/react-44ms";
import { MakeMyInterfaceLean } from "../../utils";

import { ManualAddressExpects } from "./manual-address-2023";

export type LeanManualAddress = MakeMyInterfaceLean<
  ManualAddressExpects,
  string
>;

interface Register_LeanManualAddress_OntoYour_ManualAddress_Props {
  leanManualAddress: LeanManualAddress;
  formRefManualAddress: React44ms.Api.TypedRef<ManualAddressExpects>;
}
export const Register_LeanManualAddress_Onto_ManualAddress = (
  props: Register_LeanManualAddress_OntoYour_ManualAddress_Props
) => {
  Object.entries(props.leanManualAddress).forEach(([key, value]) => {
    React44ms.Api.Yield([
      props.formRefManualAddress,
      React44ms.Api.Convenience.RefPrimitive.on<ManualAddressExpects>(
        key as keyof ManualAddressExpects
      ),
      React44ms.Api.YieldAValueAtTheEnd(value),
    ]);
  });
};
